import tw, { styled } from 'twin.macro';

export const StyledSpinnerWrapper = styled.div`
  ${tw`absolute`}
  ${tw`opacity-100`}
  ${tw`top-0 bottom-0 left-0 right-0`}
  ${tw`z-20`}
`;

export const StyledWrapper = styled.div`
  ${tw`relative`}
`;

export const StyledFormContent = styled.div<{ isLoading?: boolean }>`
  ${({ isLoading }) => isLoading && tw`opacity-25`}
`;
